import React from "react";

const Message = () => {
  return (
    <div id="message">
      <p>
        Si no encuentras tu firma o algún dato es incorrecto, por favor{" "}
        <a href="mailto:payroll@possumus.tech?subject=firma">
          ponte en contacto con nosotros
        </a>
        .
      </p>
    </div>
  );
};

export default Message;
